import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ae1ebed8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ae1ebed8&style=true&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1ebed8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae1ebed8')) {
      api.createRecord('ae1ebed8', component.options)
    } else {
      api.reload('ae1ebed8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ae1ebed8&scoped=true&", function () {
      api.rerender('ae1ebed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/pcManage/depthManage/index.vue"
export default component.exports